module.exports = __webpack_public_path__ + "img/x.df13156b.svg";